import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import OrderElement from './orderElement';
import AddLink from './addLink';
import TotalValues from './totalValues';

class Detail extends Component {
  renderBody() {
    const {detail} = this.props;

    return detail.map((element, index) => {
      return (<OrderElement key={index} element={element} index={index} />);
    });
  }

  render() {
    if (this.props.loading) {
      return (
        <Card raised fluid className='provider-manual-order-loader'>
          <Loader active inline='centered' />
        </Card>
      );
    }

    return (
      <Card raised fluid className='provider-manual-order-detail'>
        <Table>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell>Disp.</Table.HeaderCell>
              <Table.HeaderCell>Código</Table.HeaderCell>
              <Table.HeaderCell>ICC</Table.HeaderCell>
              <Table.HeaderCell>SCC</Table.HeaderCell>
              <Table.HeaderCell>MAD</Table.HeaderCell>
              <Table.HeaderCell>BO</Table.HeaderCell>
              <Table.HeaderCell>OH</Table.HeaderCell>
              <Table.HeaderCell>OO</Table.HeaderCell>
              <Table.HeaderCell>Fact.</Table.HeaderCell>
              <Table.HeaderCell>Recibido</Table.HeaderCell>
              <Table.HeaderCell>SOQ V.</Table.HeaderCell>
              <Table.HeaderCell>SOQ P.</Table.HeaderCell>
              <Table.HeaderCell>Pedido</Table.HeaderCell>
              <Table.HeaderCell>FOB</Table.HeaderCell>
              <Table.HeaderCell>FOB Total</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.renderBody()}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan='8'>
                <AddLink />
              </Table.HeaderCell>
              <Table.HeaderCell colSpan='8' textAlign='right'>
                <TotalValues />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'detail': state.providerManualOrder.detail,
    'loading': state.providerManualOrder.loading,
  };
};

export default connect(mapStateToProps)(Detail);
